const clientStoriesQuery = (postsPerPage = Number, offset = Number, activeFilters) => (
    `query ClientStories {
        clientStories(
            where: {
                orderby: {order: ASC, field: MENU_ORDER},
                offsetPagination: {size: ${postsPerPage}, offset: ${offset}},
                activeFilters: ${activeFilters}
            }) {
            edges {
                node {
                    slug
                    title
                    date
                    clientStory {
                        excerpt
                        featuredImage {
                            sizes(size: LARGE)
                            sourceUrl(size: LARGE)
                            srcSet(size: LARGE)
                        }
                        itemScrollerImage {
                            sizes(size: LARGE)
                            sourceUrl(size: LARGE)
                            srcSet(size: LARGE)
                        }
                        itemScrollerImageOverlayColour
                    }
                }
            }
            pageInfo {
                total
            }
        }
    }`
);

export default clientStoriesQuery;
